import "./UserBeam.module.css";
import Header from "@/reusable_sections/Header";
import BrukerBeam from "./sections/BrukerBeam";
import Footer from "@/reusable_sections/Footer";
export default function UserBeamPage() {
  return <div>
      <Header />
      <BrukerBeam />
      <Footer />
    </div>;
}